import { CountryPriceType } from '../types/pricing.types';
import { PricingCountryFilters } from './pricing-country.state';

export const PRICING_COUNTRY_NAME = 'PricingCountry';

export class LoadPricingCountriesListAction {
  static type = `[${PRICING_COUNTRY_NAME}] LoadPricingCountriesListAction`;

  constructor(
    public filters: PricingCountryFilters,
    public pageToLoad = 1
  ) {}
}

export class GetPricingCountryAction {
  static type = `[${PRICING_COUNTRY_NAME}] GetPricingCountryAction`;

  constructor(public id: string) {}
}

export class UpdatePricingCountryAction {
  static type = `[${PRICING_COUNTRY_NAME}] UpdatePricingCountryAction`;

  constructor(
    public countryId: string,
    public body: { currency?: string; notes?: string }
  ) {}
}

export class AddPricingCountryBundlePriceAction {
  static type = `[${PRICING_COUNTRY_NAME}] AddPricingCountryBundlePriceAction`;

  constructor(
    public countryId: string,
    public bundleId: string,
    public price: number,
    public priceType: CountryPriceType,
    public validFrom: Date
  ) {}
}

export class UpdatePricingCountryBundlePriceAction {
  static type = `[${PRICING_COUNTRY_NAME}] UpdatePricingCountryBundlePriceAction`;

  constructor(
    public countryId: string,
    public pivotId: string,
    public price: number,
    public validFrom?: Date
  ) {}
}

export class DeletePricingCountryBundlePriceAction {
  static type = `[${PRICING_COUNTRY_NAME}] DeletePricingCountryBundlePriceAction`;

  constructor(
    public countryId: string,
    public pivotId: string
  ) {}
}
